"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MTGFuturesAppProcessor = exports.getMTGFuturesTradeRangeMinBottom = exports.MTGFuturesTradeRangeMaxTop = exports.MTGFuturesConditionMinOffsetWithCurrentPrice = exports.MTGFuturesMinCondition = exports.MTGFuturesMaxCondition = exports.MTGFuturesPriceScalePercentageAccuracy = exports.MTGFuturesTakeProfitRatioAccuracy = exports.MTGFuturesDefaultLeverage = exports.MTGFuturesDefaultVolumeScale = exports.MTGFuturesDefaultSafetyOrders = exports.MTGFuturesMinSafetyOrders = exports.MTGFuturesTakeProfitRatioMaxShort = exports.MTGFuturesTakeProfitRatioMaxLong = exports.MTGFuturesTakeProfitRatioMin = exports.MTGFuturesPriceScaleFixedNumMax = exports.MTGFuturesPriceScalePercentageMax = exports.MTGFuturesPriceScalePercentageMin = void 0;
const react_1 = require("react");
const trade_utils_lib_1 = require("trade_utils_lib");
const TradeAPILib_1 = require("TradeAPILib");
const useMTGFuturesParamsCheck_1 = require("./useMTGFuturesParamsCheck");
const GridTradingUtils_1 = require("../GridTrading/GridTradingUtils");
const MartingaleTradingTools_1 = require("./MartingaleTradingTools");
exports.MTGFuturesPriceScalePercentageMin = 0.001;
exports.MTGFuturesPriceScalePercentageMax = 0.15;
exports.MTGFuturesPriceScaleFixedNumMax = 10000;
exports.MTGFuturesTakeProfitRatioMin = 0.002;
exports.MTGFuturesTakeProfitRatioMaxLong = 999.9999;
exports.MTGFuturesTakeProfitRatioMaxShort = 0.9999;
exports.MTGFuturesMinSafetyOrders = "1";
exports.MTGFuturesDefaultSafetyOrders = "6";
exports.MTGFuturesDefaultVolumeScale = "1.1";
exports.MTGFuturesDefaultLeverage = 3;
exports.MTGFuturesTakeProfitRatioAccuracy = 3;
exports.MTGFuturesPriceScalePercentageAccuracy = 3;
exports.MTGFuturesMaxCondition = "9999999";
exports.MTGFuturesMinCondition = "0";
// 触发价相对于当前价格的最小偏移量
exports.MTGFuturesConditionMinOffsetWithCurrentPrice = 0.0005;
// 价格区间上区间最大值
exports.MTGFuturesTradeRangeMaxTop = 1000000;
// 价格区间下区间最小值 (当前base的最小精度)
const getMTGFuturesTradeRangeMinBottom = (precision) => new trade_utils_lib_1.SafeDecimal(10).pow(new trade_utils_lib_1.SafeDecimal(precision || 2).negated()).toString();
exports.getMTGFuturesTradeRangeMinBottom = getMTGFuturesTradeRangeMinBottom;
const MTGFuturesAppProcessor = (props) => {
    var _a;
    const { trend, leverage, extra_margin, extra_margin_amount, sub_order_type = TradeAPILib_1.MartingaleSubType.normal, symbol, quoteInvestment, balance, currentPrice, safetyOrders, takeProfitRatio, priceScaleParams, priceScaleType, orderType, volumeScale, takeProfitForBot, stopLossForBot, condition, $st, signal, stopScalingPrice, stopScalingPriceBottom, } = props;
    // 加仓次数范围
    const { maxSafetyOrders, minSafetyOrders } = (0, react_1.useMemo)(() => {
        const info = (0, MartingaleTradingTools_1.getMaxSafetyOrdersByVolumeScale)(volumeScale, TradeAPILib_1.ExchangeOrderType.futures_martingale);
        return {
            maxSafetyOrders: (info === null || info === void 0 ? void 0 : info.maxSafeOrder) || exports.MTGFuturesDefaultSafetyOrders,
            minSafetyOrders: (info === null || info === void 0 ? void 0 : info.minSafetyOrder) || exports.MTGFuturesMinSafetyOrders,
        };
    }, [volumeScale]);
    const emptyErrors = (0, react_1.useMemo)(() => {
        const empty = [];
        if (!priceScaleParams) {
            empty.push("martingale_price_scale");
        }
        if (!takeProfitRatio) {
            empty.push("martingale_take_profit_ratio");
        }
        if (!quoteInvestment) {
            empty.push("trading_total_investment");
        }
        if (!safetyOrders) {
            empty.push("martingale_safety_orders");
        }
        return empty;
    }, [quoteInvestment, priceScaleParams, takeProfitRatio, safetyOrders]);
    const [price, precision] = (0, react_1.useMemo)(() => {
        var _a, _b;
        const _precision = trade_utils_lib_1.SafeDecimal.max((_a = symbol.precision) !== null && _a !== void 0 ? _a : 0, (_b = symbol.precisionCost) !== null && _b !== void 0 ? _b : 0).toNumber();
        // 下单预检 如果存在触发价，price = condition, 不存在 price = currentPrice;
        return [trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(condition || currentPrice, _precision), _precision];
    }, [condition, currentPrice, symbol.precision, symbol.precisionCost]);
    const parseBalance = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(balance, precision);
    const priceScaleState = (0, react_1.useMemo)(() => {
        const minCost = new trade_utils_lib_1.SafeDecimal(10).pow(precision * -1);
        const priceScaleParamsValue = new trade_utils_lib_1.SafeDecimal(priceScaleParams);
        const state = {
            state: "normal",
            min: "",
            max: "",
            errorMsg: "",
        };
        switch (priceScaleType) {
            case TradeAPILib_1.MartingalePriceScaleType.percentage: {
                state.min = `${new trade_utils_lib_1.SafeDecimal(exports.MTGFuturesPriceScalePercentageMin).times(100)}%`;
                state.max = `${new trade_utils_lib_1.SafeDecimal(exports.MTGFuturesPriceScalePercentageMax).times(100)}%`;
                if (priceScaleParams) {
                    const percentage = new trade_utils_lib_1.SafeDecimal(priceScaleParamsValue).div(100);
                    if (percentage.gte(0) && percentage.lt(exports.MTGFuturesPriceScalePercentageMin)) {
                        state.state = "small";
                        state.errorMsg = $st("bot.mtg.futures.params.error.small", { num: state.min });
                    }
                    else if (percentage.gt(exports.MTGFuturesPriceScalePercentageMax)) {
                        state.state = "large";
                        state.errorMsg = $st("bot.mtg.futures.params.error.large", { num: state.max });
                    }
                }
                break;
            }
            case TradeAPILib_1.MartingalePriceScaleType.fixed_num: {
                state.min = minCost.toString();
                state.max = exports.MTGFuturesPriceScaleFixedNumMax;
                if (priceScaleParams) {
                    if (priceScaleParamsValue.lte(0) && priceScaleParamsValue.lt(minCost)) {
                        state.state = "small";
                        state.errorMsg = $st("bot.mtg.futures.params.error.small", { num: state.min });
                    }
                    else if (priceScaleParamsValue.gt(exports.MTGFuturesPriceScaleFixedNumMax)) {
                        state.state = "large";
                        state.errorMsg = $st("bot.mtg.futures.params.error.large", { num: state.max });
                    }
                }
            }
        }
        return state;
    }, [precision, priceScaleParams, priceScaleType, $st]);
    const takeProfitRatioState = (0, react_1.useMemo)(() => {
        const maxRatio = trend === TradeAPILib_1.GridFuturesTrend.long ? exports.MTGFuturesTakeProfitRatioMaxLong : exports.MTGFuturesTakeProfitRatioMaxShort;
        const state = {
            state: "normal",
            min: `${new trade_utils_lib_1.SafeDecimal(exports.MTGFuturesTakeProfitRatioMin).times(100)}%`,
            max: `${new trade_utils_lib_1.SafeDecimal(maxRatio).times(100)}%`,
            errorMsg: "",
        };
        const takeProfitRatioValue = new trade_utils_lib_1.SafeDecimal(takeProfitRatio).div(100);
        if (takeProfitRatio) {
            if (takeProfitRatioValue.gte(0) && takeProfitRatioValue.lt(exports.MTGFuturesTakeProfitRatioMin)) {
                state.state = "small";
                state.errorMsg = $st("bot.mtg.futures.params.error.small", { num: state.min });
            }
            else if (takeProfitRatioValue.gt(maxRatio)) {
                state.state = "large";
                state.errorMsg = $st("bot.mtg.futures.params.error.large", { num: state.max });
            }
        }
        return state;
    }, [$st, takeProfitRatio, trend]);
    const safetyOrdersState = (0, react_1.useMemo)(() => {
        const state = {
            state: "normal",
            min: minSafetyOrders,
            max: maxSafetyOrders,
            errorMsg: "",
        };
        if (safetyOrders) {
            const safetyOrdersDecimal = new trade_utils_lib_1.SafeDecimal(safetyOrders);
            const minSafetyOrdersDecimal = new trade_utils_lib_1.SafeDecimal(minSafetyOrders);
            const maxSafetyOrdersDecimal = new trade_utils_lib_1.SafeDecimal(maxSafetyOrders);
            if (safetyOrdersDecimal.lt(minSafetyOrdersDecimal)) {
                state.state = "small";
                state.errorMsg = $st("bot.mtg.futures.params.error.small", { num: state.min });
            }
            else if (safetyOrdersDecimal.gt(maxSafetyOrdersDecimal)) {
                state.state = "large";
                state.errorMsg = $st("bot.mtg.futures.params.error.large", { num: state.max });
            }
        }
        return state;
    }, [$st, maxSafetyOrders, minSafetyOrders, safetyOrders]);
    const conditionState = (0, react_1.useMemo)(() => {
        const state = {
            state: "normal",
            min: exports.MTGFuturesMinCondition,
            max: exports.MTGFuturesMaxCondition,
        };
        if (condition) {
            const conditionDecimal = new trade_utils_lib_1.SafeDecimal(condition);
            const currentPriceDecimal = new trade_utils_lib_1.SafeDecimal(currentPrice);
            const offsetDownPrice = currentPriceDecimal.times(new trade_utils_lib_1.SafeDecimal(1).sub(exports.MTGFuturesConditionMinOffsetWithCurrentPrice));
            const offsetUpPrice = currentPriceDecimal.times(new trade_utils_lib_1.SafeDecimal(1).add(exports.MTGFuturesConditionMinOffsetWithCurrentPrice));
            const stopScalingPriceDecimal = new trade_utils_lib_1.SafeDecimal(stopScalingPrice);
            const stopScalingPriceBottomDecimal = new trade_utils_lib_1.SafeDecimal(stopScalingPriceBottom);
            // [99.5%, 100.5%]
            if (conditionDecimal.gte(offsetDownPrice) && conditionDecimal.lte(offsetUpPrice)) {
                state.state = "notEnough";
                state.errorMsg = $st("bot.mtg.futures.create.condition.with.price");
            }
            else if (conditionDecimal.lte(new trade_utils_lib_1.SafeDecimal(state.min))) {
                state.state = "small";
                state.errorMsg = $st("bot.mtg.futures.create.condition.min", { min: state.min });
            }
            else if (conditionDecimal.gt(new trade_utils_lib_1.SafeDecimal(state.max))) {
                state.state = "large";
                state.errorMsg = $st("bot.mtg.futures.create.condition.max", { max: state.max });
            }
            else if (stopScalingPrice && conditionDecimal.gt(stopScalingPriceDecimal)) {
                // 触发价大于交易区间上区间
                state.state = "notInRange";
                state.errorMsg = $st("bot.mtg.futures.trade.condition.in.range");
            }
            else if (stopScalingPriceBottom && conditionDecimal.lt(stopScalingPriceBottomDecimal)) {
                // 触发价小于交易区间下区间
                state.state = "notInRange";
                state.errorMsg = $st("bot.mtg.futures.trade.condition.in.range");
            }
        }
        return state;
    }, [$st, condition, currentPrice, stopScalingPrice, stopScalingPriceBottom]);
    const checkParams = (0, react_1.useMemo)(() => {
        return {
            quote: symbol.quote,
            trend,
            leverage,
            extra_margin: extra_margin,
            quote_investment: quoteInvestment || undefined,
            extra_margin_amount: extra_margin_amount || undefined,
            open_price: price,
            base: symbol.base,
            price_scale_type: priceScaleType,
            price_scale_param: priceScaleState.state === "normal"
                ? priceScaleType === TradeAPILib_1.MartingalePriceScaleType.percentage
                    ? new trade_utils_lib_1.SafeDecimal(priceScaleParams).div(100).toString()
                    : priceScaleParams
                : "",
            safety_orders: Number(safetyOrders || 0),
            volume_scale: volumeScale,
        };
    }, [
        symbol.quote,
        symbol.base,
        trend,
        leverage,
        extra_margin,
        extra_margin_amount,
        price,
        priceScaleType,
        priceScaleParams,
        priceScaleState,
        safetyOrders,
        volumeScale,
        quoteInvestment,
    ]);
    const { checkResult, checkLoading } = (0, useMTGFuturesParamsCheck_1.useMTGFuturesParamsCheck)(checkParams, {
        investPrecision: (_a = symbol.precisionCost) !== null && _a !== void 0 ? _a : 0,
    }, {
        inputError: [takeProfitRatioState.state, priceScaleState.state, safetyOrdersState.state, conditionState.state].some((stat) => stat !== "normal"),
    });
    const investState = (0, react_1.useMemo)(() => {
        var _a, _b;
        const state = {
            state: "normal",
            min: (_a = checkResult === null || checkResult === void 0 ? void 0 : checkResult.minInvestment) !== null && _a !== void 0 ? _a : "",
            max: (_b = checkResult === null || checkResult === void 0 ? void 0 : checkResult.maxInvestment) !== null && _b !== void 0 ? _b : "",
        };
        const investment = new trade_utils_lib_1.SafeDecimal(quoteInvestment);
        if ((quoteInvestment === null || quoteInvestment === void 0 ? void 0 : quoteInvestment.trim().length) > 0) {
            if (investment.greaterThan(new trade_utils_lib_1.SafeDecimal(state.max))) {
                state.state = "large";
            }
            else if (investment.lessThan(new trade_utils_lib_1.SafeDecimal(state.min))) {
                state.state = "small";
            }
            else if (investment.gt(new trade_utils_lib_1.SafeDecimal(balance))) {
                state.state = "notEnough";
            }
        }
        return state;
    }, [balance, checkResult, quoteInvestment]);
    const isError = (0, react_1.useMemo)(() => {
        const isPriceScaleError = priceScaleState.state !== "normal";
        const isTakeProfitRatioError = takeProfitRatioState.state !== "normal";
        const isInvestError = quoteInvestment ? investState.state !== "normal" : false;
        const isConditionError = conditionState.state !== "normal";
        const isSafetyOrdersError = safetyOrdersState.state !== "normal";
        return (isInvestError ||
            emptyErrors.length > 0 ||
            isPriceScaleError ||
            isTakeProfitRatioError ||
            isConditionError ||
            isSafetyOrdersError);
    }, [
        conditionState.state,
        emptyErrors.length,
        investState.state,
        priceScaleState.state,
        quoteInvestment,
        safetyOrdersState.state,
        takeProfitRatioState.state,
    ]);
    const condition_direction = GridTradingUtils_1.GridTradingUtils.getConditionDirection(condition !== null && condition !== void 0 ? condition : "", String(currentPrice));
    return {
        sub_order_type,
        trend,
        priceScale: priceScaleParams,
        priceScaleMode: priceScaleType,
        takeProfitRatio,
        quoteInvestment,
        leverage,
        safetyOrders,
        safetyOrdersState,
        availableBalance: parseBalance,
        symbol,
        orderType,
        investState,
        emptyErrors,
        precision,
        volumeScale,
        currentPrice: currentPrice,
        takeProfitRatioState,
        priceScaleState,
        checkRequest: checkParams,
        checkResult,
        isError,
        checkLoading,
        takeProfitForBot,
        stopLossForBot,
        condition,
        condition_direction,
        conditionState,
        signal,
        stopScalingPrice,
        stopScalingPriceBottom,
    };
};
exports.MTGFuturesAppProcessor = MTGFuturesAppProcessor;
